import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const EmailNew = MatxLoadable({
    loader: () =>
        import ("./Create")
})

const EmailView = MatxLoadable({
    loader: () =>
        import ("./View")
})

const EmailUpdate = MatxLoadable({
    loader: () =>
        import ("./Update")
})

const Routes = [{
        path: "/new_newsletter",
        component: EmailNew,
        auth: authRoles.Newsletters
    },
    {
        path: "/view_newsletter",
        component: EmailView,
        auth: authRoles.Newsletters
    },
    {
        path: "/update_newsletter/:id",
        component: EmailUpdate,
        auth: authRoles.Newsletters
    }
];

export default Routes;